import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/ap-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "pane" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    style: {"max-width":"400px"}
  }),
  /*#__PURE__*/_createVNode("h3", { style: {"text-align":"center"} }, "Logging in with Geotab...")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GeotabSetupScreen = _resolveComponent("GeotabSetupScreen")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_ctx.showGeotabSetup)
    ? (_openBlock(), _createBlock(_component_GeotabSetupScreen, { key: 0 }))
    : (_openBlock(), _createBlock(_component_el_container, {
        key: 1,
        id: "geotab-login-view"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}